import React from "react";

const FVFRPricing = ({ title, descriptionMain, descriptionNote }) => {
  return (
    <section className="fvfr-pricing-section">
      <div className="container">
        <h2
          className="fvfr-pricing-title text-center"
          data-aos="fade-up"
          data-aos-once="true"
        >
          {title}
        </h2>

        <p
          className="fvfr-pricing-main"
          data-aos="fade-up"
          data-aos-delay="100"
          data-aos-once="true"
        >
          {descriptionMain}
        </p>

        <div
          className="fvfr-pricing-note-box"
          data-aos="fade-up"
          data-aos-delay="200"
          data-aos-once="true"
        >
          <p>{descriptionNote}</p>
        </div>

        <div
          className="fvfr-pricing-actions"
          data-aos="fade-up"
          data-aos-delay="300"
          data-aos-once="true"
        >
          <a href="tel:+971544792905" className="mini-btn primary">
            Call Now
          </a>
          <a
            href="https://wa.me/971544792905"
            target="_blank"
            rel="noopener noreferrer"
            className="mini-btn secondary-dark"
          >
            WhatsApp Now
          </a>
        </div>
      </div>
    </section>
  );
};

export default FVFRPricing;
